import { NavLinkItem } from "@webcore/layouts/ContentLayout.tsx";

// Split out of ContentSiteRoutes.tsx — its createBrowserRouter() call needs browser APIs the
// Node-based prerender script can't provide.
export const contentNavLinks: NavLinkItem[] = [
  { label: "platform", to: "/#platform" },
  { label: "workflows", to: "/#workflows" },
  { label: "how it works", to: "/#how-it-works" },
  { label: "for saas", to: "/solutions/saas" },
  { label: "for ecommerce", to: "/solutions/ecommerce" },
  { label: "blog", to: "/blog" },
];
